import  { useEffect } from 'react'

const PageTitle = ({title}) => {
    useEffect (() => {
        document.title = title + " || Khwaja Yunus Ali Medical College & Hospital";
    },[title])
}

export default PageTitle